// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';
import { MrText, MrInputSelectDeprecated } from '@ion/components';

import BaseTable from 'app/components/analytics-builder/base-table/BaseTable';
import EGSM, { EGSM_FIXED_OPTIONS, EGSM_SIGNALS } from 'app/components/analytics-builder/EGSM';
import { useConsentCategoriesContext } from 'app/context/consent-categories-context';

// No strictly-necessary flag exists on consent categories, so exclusion is by CMP
// convention: OneTrust C0001, Cookiebot necessary, Osano ESSENTIAL, plus name matches
const STRICTLY_NECESSARY_CODES = ['c0001', 'necessary', 'essential', 'strictly_necessary'];
const STRICTLY_NECESSARY_NAME = /strictly[\s_-]*necessary|^necessary$|^essential$/i;
const SENTINEL_VALUES = Object.values(EGSM);

export default function EgsmSignalMappingTable({ formState, setField }) {
  const { consentCategories } = useConsentCategoriesContext();
  const options = buildOptions(consentCategories);

  return (
    <BaseTable styleNames="noBorders">
      <tbody>
        {EGSM_SIGNALS.map(({ signal, formField }) => {
          const selectName = `sync-parentGTag-${formField}`;
          return (
            <tr key={signal}>
              <td>
                <MrText styleNames="bold" component="span">
                  {signal}
                </MrText>
              </td>
              <td>
                <MrInputSelectDeprecated
                  name={selectName}
                  testId={`egsmSignalSelect-${signal}`}
                  options={options}
                  onChange={setField}
                  value={formState[selectName]?.value ?? EGSM.NOT_SET}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </BaseTable>
  );
}

function buildOptions(consentCategories) {
  const categoryOptions = (consentCategories ?? [])
    .filter(category => !STRICTLY_NECESSARY_CODES.includes(category.code?.toLowerCase()))
    .filter(category => !STRICTLY_NECESSARY_NAME.test(category.name ?? ''))
    .filter(category => !SENTINEL_VALUES.includes(category.code?.toUpperCase()))
    .map(category => ({ value: category.code, text: category.displayName }));

  return [...EGSM_FIXED_OPTIONS.map(option => ({ value: option.value, text: option.label })), ...categoryOptions];
}

EgsmSignalMappingTable.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
};
